<template>
  <v-container fluid class="ai-page">
    <!-- Filtros -->
    <v-card class="ai-panel mb-4" elevation="0">
      <div class="ai-filtros">
        <v-select
          v-if="user.tipo == 'ADMIN'"
          outlined
          dense
          hide-details
          background-color="white"
          prepend-inner-icon="mdi-domain"
          v-model="empresaSelecionada"
          :items="empresas"
          item-text="nome"
          item-value="id"
          label="Empresa"
          class="ai-filtro-empresa"
        ></v-select>

        <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="290px">
          <template v-slot:activator="{ on }">
            <v-text-field light v-model="dateFormattedInicio" label="Data início" persistent-hint append-icon="mdi-calendar" @blur="date = parseDate(dateFormattedInicio)" v-on="on" outlined dense hide-details class="ai-filtro-data"></v-text-field>
          </template>
          <v-date-picker v-model="dataInicio" no-title color="primary" @input="menu1 = false"></v-date-picker>
        </v-menu>

        <v-text-field v-model="horaInicio" label="Hora início" light type="time" outlined dense hide-details class="ai-filtro-hora"></v-text-field>

        <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="290px">
          <template v-slot:activator="{ on }">
            <v-text-field light v-model="dateFormattedFim" label="Data fim" persistent-hint append-icon="mdi-calendar" @blur="date = parseDate(dateFormattedFim)" v-on="on" outlined dense hide-details class="ai-filtro-data"></v-text-field>
          </template>
          <v-date-picker v-model="dataFim" no-title color="primary" @input="menu2 = false"></v-date-picker>
        </v-menu>

        <v-text-field v-model="horaFim" label="Hora fim" light type="time" outlined dense hide-details class="ai-filtro-hora"></v-text-field>

        <v-btn color="primary" depressed @click="carregaChamados(empresaSelecionada ? empresaSelecionada : companyobj.id)">
          <v-icon left>mdi-magnify</v-icon>Buscar
        </v-btn>
      </div>
    </v-card>

    <!-- Resultado -->
    <v-card class="ai-panel" elevation="0">
      <div class="ai-panel__head">
        <div class="ai-panel__title">
          <v-icon>mdi-bell-ring</v-icon>
          Relatório de chamados
          <span class="ai-count">{{ tabela.conteudo.length }}</span>
        </div>
        <div class="ai-panel__spacer"></div>
        <v-text-field v-model="tabela.busca" append-icon="mdi-magnify" label="Filtrar" single-line hide-details dense outlined class="ai-search"></v-text-field>
        <download-csv v-if="tabela.conteudo.length" :data="tabela.conteudo" name="chamados.csv">
          <v-btn outlined color="primary"><v-icon left>mdi-file-download-outline</v-icon>Exportar</v-btn>
        </download-csv>
      </div>

      <v-data-table
        :search="tabela.busca"
        :headers="tabela.cabecalho"
        :items="tabela.conteudo"
        class="ai-datatable"
        :loading="tabela.carregamento"
        loading-text="Aguarde, buscando chamados..."
        :footer-props="{ 'items-per-page-text': 'Linhas por página', 'items-per-page-all-text': 'Tudo' }"
      >
        <template v-slot:[`item.chamadorNome`]="{ item }">
          <v-icon small color="primary" class="mr-1">mdi-bell-ring</v-icon>{{ item.chamadorNome || '—' }}
        </template>
        <template v-slot:[`item.inicio`]="{ item }">{{ formatDateHour(item.inicio) }}</template>
        <template v-slot:[`item.fim`]="{ item }">{{ item.fim ? formatDateHour(item.fim) : '—' }}</template>
        <template v-slot:[`item.created`]="{ item }">
          <v-chip x-small label color="primary" text-color="white" v-if="item.fim">{{ calculaTempoEspera(item.inicio, item.fim) }}</v-chip>
          <v-chip x-small label color="warning" text-color="white" v-else>em aberto</v-chip>
        </template>
        <template slot="no-data">
          <div class="py-6">
            <v-alert dense text outlined color="warning" class="ma-0 d-inline-flex">
              <v-icon left color="warning">mdi-clipboard-text-off</v-icon>Nenhum chamado encontrado no período
            </v-alert>
          </div>
        </template>
        <template slot="no-results">
          <div class="py-6">
            <v-alert dense text outlined color="warning" class="ma-0 d-inline-flex">
              <v-icon left color="warning">mdi-magnify-close</v-icon>Sua pesquisa por "{{ tabela.busca }}" não trouxe resultados
            </v-alert>
          </div>
        </template>
      </v-data-table>
    </v-card>

    <Snackbar ref=chamaSnackbar />
    <loading :active.sync="isLoading" :can-cancel="true" color="#038b8b" :is-full-page="fullPage"></loading>
  </v-container>
</template>

<script>
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  import { baseApiUrl } from '@/global'
  import Snackbar from '../componentes/snackbar.vue'
  import axios from 'axios'
  import { mapState } from 'vuex'
  import moment from 'moment'
  export default {
    components: {Snackbar, Loading},
    data: vm => ({
      isLoading: false,
      fullPage: true,
      date: new Date().toISOString().substring(0, 10),
      mask:"##:##:##",
      menu: false,
      empresas: [],
      empresaSelecionada: '',
      tabela: {
        cabecalho: [
          { text: 'Chamador', value: 'chamadorNome', align: 'start' },
          { text: 'Início', value: 'inicio' },
          { text: 'Fim', value: 'fim' },
          { text: 'Tempo de chamado', value: 'created' },
          { text: 'Finalizado por', value: 'usuarioNome' },
        ],
        conteudo: [],
        busca: '',
        carregamento: false,
      },
      menu1: false,
      menu2: false,
      dateFormattedInicio: vm.formatDate(new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().substring(0, 10)),
      dateFormattedFim: vm.formatDate(new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().substring(0, 10)),
      dataInicio: new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().substring(0, 10),
      dataFim: new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().substring(0, 10),
      horaInicio: '00:00',
      horaFim: '23:59',
      editedIndex: -1,
    }),

    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
      user: state => state.userObj,
      companyobj: state => state.companyObj,
      computedDateFormattedInicio () {
        return this.formatDate(this.dataInicio)
      },
      computedDateFormattedFim () {
        return this.formatDate(this.dataFim)
      },
    }),

    watch: {
      dataInicio() {
        this.dateFormattedInicio = this.formatDate(this.dataInicio)
      },

      dataFim() {
        this.dateFormattedFim = this.formatDate(this.dataFim)
      },

      empresas() {
        this.empresaSelecionada = this.empresas[0].id
        this.carregaChamados(this.empresaSelecionada)
      },
    },

    mounted () {
      if (this.user.tipo == 'ADMIN') {
        this.carregaEmpresas()
      } else {
        this.carregaChamados(this.companyobj.id)
      }
    },

    methods: {
      async carregaEmpresas() {
        await axios.get(baseApiUrl + 'Empresas?filter={"order":"nome ASC", "fields":{"nome": true, "id": true}}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data.length > 0) {
            this.empresas = response.data
          }
        })
      },

      async carregaChamados(id) {
        this.tabela.carregamento = true
        this.tabela.conteudo = []
        await axios.get(baseApiUrl + 'Chamados?filter={"where":{"and":[{"empresaId":"' + id + '"},{"inicio":{"gt":"' + this.dataInicio + 'T' + this.horaInicio + ':00.000Z"}},{"inicio":{"lt":"' + this.dataFim + 'T' + this.horaFim + ':00.000Z"}}]}}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          this.tabela.conteudo = response.data
          this.tabela.carregamento = false
        })
      },

      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      formatDateHour(data_hora) {
        let data = data_hora.substr(0, 10).split('-')
        data = data[2] + '/' + data[1] + '/' + data[0]
        let hora = data_hora.substr(11, 8)

        return data + ' às ' + hora
      },

      parseDate (date) {
        if (!date) return null

        const [month, day, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },

      calculaTempoEspera(login, logout) {
        let data1_str = login;
        let data2_str = logout;

        // converter para objetos Date
        let data1 = moment(data1_str);
        let data2 = moment(data2_str);

        // calcular diferença em milissegundos
        let diferenca = moment.duration(data2.diff(data1));

        return (diferenca.hours() < 10 ? '0' + diferenca.hours() : diferenca.hours()) + ':' +
              (diferenca.minutes() < 10 ? '0' + diferenca.minutes() : diferenca.minutes()) + ':' +
              (diferenca.seconds() < 10 ? '0' + diferenca.seconds() : diferenca.seconds())
      },
    },
  }
</script>

<style scoped>
.ai-filtros {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  padding: 16px 20px;
}
.ai-filtro-empresa {
  max-width: 260px;
  flex: 1 1 200px;
}
.ai-filtro-data {
  max-width: 170px;
}
.ai-filtro-hora {
  max-width: 130px;
}
</style>
